import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setLanguage } from "../../redux/language/actions";
import { useTranslation } from "react-i18next";

interface LanguageOption {
  value: string;
  src: string;
  alt: string;
}

const options: LanguageOption[] = [
  {
    value: "de",
    src: "https://flagcdn.com/w40/de.png",
    alt: "German",
  },
  {
    value: "en",
    src: "https://flagcdn.com/w40/gb.png",
    alt: "English",
  },
];

export default function LanguageDropdown() {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [selected, setSelected] = useState<LanguageOption>(options[0]);
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const storedLang = localStorage.getItem("selectLang");
    if (storedLang) {
      const parsedLang: LanguageOption = JSON.parse(storedLang);
      setSelected(parsedLang);
      i18n.changeLanguage(parsedLang.value);
      // dispatch(setLanguage(parsedLang.value));
    }
  }, []);

  const toggleDropdown = (): void => {
    setIsOpen(prev => !prev);
  };

  const handleSelect = (option: LanguageOption): void => {
    setSelected(option);
    localStorage.setItem("selectLang", JSON.stringify(option));
    localStorage.setItem("language", option.value);
    setIsOpen(false);

    const selectedLang = option.value;
    i18n.changeLanguage(selectedLang);
    dispatch(setLanguage(selectedLang)); // Dispatch the setLanguage action
  };

  return (
    <div
      style={{ position: "relative", width: "50px", height: "36px" }}
      className=" me-lg-3 ms-lg-3"
    >
      <div
        onClick={toggleDropdown}
        style={{
          cursor: "pointer",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "36px",
          width: "50px",
          backgroundColor: "#fff",
        }}
      >
        <img
          src={selected.src}
          alt={selected.alt}
          style={{ width: "50px", height: "36px", objectFit: "cover" }}
        />
      </div>

      {isOpen && (
        <div
          style={{
            position: "absolute",
            top: "40px",
            left: 0,

            boxShadow: "0px 2px 5px rgba(0,0,0,0.2)",
            zIndex: 1000,
          }}
        >
          {options.map(option => (
            <div
              key={option.value}
              onClick={() => handleSelect(option)}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                paddingTop: "5px",
              }}
            >
              <img
                src={option.src}
                alt={option.alt}
                style={{ width: "50px", height: "36px", objectFit: "cover" }}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
